import trackAnalytics from './gaia/trackAnalytics';

export default (fileDownloadUrl, permalink, cb) => {
    fetch(fileDownloadUrl)
        .then(response => {
            return response.text();
        }).then(result => {

            const file_type = fileDownloadUrl.split('.')[1];
            const dataString = result;

            const filename = permalink;
            const anchor = document.createElement('a');

            const url = URL.createObjectURL(
                new Blob([dataString], {type: 'text/plain'})
            );
            anchor.href = url;
            anchor.target = '_blank';
            anchor.download = filename + '.' + file_type;
            anchor.click();
            cb(null);

            // Add analytics
            trackAnalytics('Download', {category: 'Map', label: file_type});
        }).catch(error => {
            console.error(error);
            cb('There was an error downloading the file.');
        });
};
